module.exports = __webpack_public_path__ + "static/media/06-about.c2fb6b11.png";